import { create } from 'zustand';
import { z } from 'zod';
import { readJSON, writeJSON } from '@/lib/storage';

const KEY = 'cc.records.v1';
const RecordsSchema = z.record(z.string(), z.object({ best: z.number().int().min(0), at: z.string() }));
type Records = z.infer<typeof RecordsSchema>;

/** Records are kept per mode, level and difficulty cap. */
export const recordKey = (modeId: string, levelId: string, bMax: number): string => `${modeId}:${levelId}:${bMax}`;

interface RecordsState {
  records: Records;
  best: (key: string) => number;
  /** returns true when the score is a new record */
  submit: (key: string, score: number) => boolean;
  reset: () => void;
}

export const useRecords = create<RecordsState>((set, get) => ({
  records: readJSON(KEY, RecordsSchema) ?? {},
  best: (key) => get().records[key]?.best ?? 0,
  submit: (key, score) => {
    if (score <= get().best(key)) return false;
    set((s) => ({ records: { ...s.records, [key]: { best: score, at: new Date().toISOString() } } }));
    return true;
  },
  reset: () => set({ records: {} }),
}));

useRecords.subscribe((s) => writeJSON(KEY, s.records));
